import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import type { LotLookupDto } from "@hisense/shared";
import { apiFetch } from "@/lib/api";
import { formatQty } from "@/domain/money";
import { ScanField, scanError } from "./ScanField";

/** Tra lô: quét tem, thấy ngay lô đó đang ở kho nào, vị trí nào, bao nhiêu dùng được / chờ kiểm / không đạt / giữ chỗ. */
export function LookupTask() {
  const { t } = useTranslation();
  const [result, setResult] = useState<LotLookupDto | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const scan = async (code: string) => {
    setBusy(true);
    setError(null);
    try {
      const res = await apiFetch<{ data: LotLookupDto }>("/warehouse-receipts/lot-lookup", { query: { code } });
      setResult(res.data);
      if (!res.data.positions.length) setError(t("scan.lotNotFound", { lot: res.data.lotNumber }));
    } catch (e) {
      setResult(null);
      setError(scanError(e, t, code));
    } finally {
      setBusy(false);
    }
  };
  const n = (v: string) => formatQty(Number(v));
  return (
    <div className="space-y-4">
      <ScanField id="scan-lookup" label={t("scan.scanLot")} placeholder={t("scan.scanLotPlaceholder")} busy={busy} onScan={(v) => void scan(v)} />
      {error && <p role="alert" className="text-sm text-danger">{error}</p>}
      {result?.positions.map((p) => (
        <article key={`${p.entryId}|${p.warehouseId}|${p.location}`} className="space-y-2 rounded-md border border-line bg-surface p-4">
          <p className="font-mono text-base font-semibold">{p.productCode}{p.subRef && <span className="text-ink-soft"> / {p.subRef}</span>}</p>
          {p.description && <p className="text-sm text-ink-soft">{p.description}</p>}
          <p className="font-mono text-sm">{p.lotNumber}</p>
          <p className="text-sm">{p.warehouseName} · <span className="font-mono">{p.location}</span></p>
          <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm sm:grid-cols-5">
            {([["available", p.available], ["pending", p.pending], ["rejected", p.rejected], ["reserved", p.reserved], ["onHand", p.onHand]] as const).map(([k, v]) => (
              <div key={k}>
                <dt className="text-2xs uppercase tracking-wide text-ink-faint">{t(`scan.qty.${k}`)}</dt>
                <dd className="font-mono tabular">{n(v)} <span className="text-2xs text-ink-faint">{p.unit}</span></dd>
              </div>
            ))}
          </dl>
          <Link to={`/products/${p.productId}/stock`} className="text-sm text-brand underline">{t("scan.openStock")}</Link>
        </article>
      ))}
    </div>
  );
}
